import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Bell } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { PageHeader, RoleBadge } from "@/components/Badges";

export default function Profile() {
  const { user } = useAuth();
  const [prefs, setPrefs] = useState(null);

  useEffect(() => { api.get("/me/preferences").then((r) => setPrefs(r.data)); }, []);

  const toggle = async (v) => {
    try {
      const { data } = await api.put("/me/preferences", { email_sop_updates: v });
      setPrefs(data);
      toast.success(v ? "You'll get an email when an SOP you follow changes" : "SOP update emails turned off");
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <div className="fade-up max-w-3xl">
      <PageHeader eyebrow="Account" title="Profile & preferences" />
      <div className="rounded-2xl border border-lasso-line bg-white p-6" data-testid="profile-card">
        <p className="font-display text-lg font-bold" data-testid="profile-name">{user.name}</p>
        <p className="mt-1 text-sm text-muted-foreground">{user.email}</p>
        <div className="mt-3"><RoleBadge role={user.role} /></div>
      </div>
      <h2 className="mb-4 mt-10 font-display text-sm font-bold uppercase tracking-[0.14em]">Notifications</h2>
      <div className="divide-y divide-lasso-line rounded-2xl border border-lasso-line bg-white">
        <div className="flex items-center justify-between gap-6 p-6">
          <div className="flex gap-3">
            <Mail className="mt-0.5 h-5 w-5 shrink-0 text-lasso-deep" />
            <div>
              <p className="text-sm font-semibold">Email me about SOP updates</p>
              <p className="mt-1 text-sm text-muted-foreground">When an SOP you acknowledged or were assigned gets a new version, we'll email you what changed.</p>
            </div>
          </div>
          {prefs && <Switch checked={prefs.email_sop_updates} onCheckedChange={toggle} data-testid="prefs-email-sop-updates" />}
        </div>
        <div className="flex gap-3 p-6 text-sm text-muted-foreground">
          <Bell className="mt-0.5 h-5 w-5 shrink-0 text-zinc-400" />
          In-app notifications (the bell) are always on. Due-date reminder emails are managed by your administrator.
        </div>
      </div>
    </div>
  );
}
